import { Warning } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

export default function ConfirmDialog({ open, onOpenChange, title = "¿Eliminar?", description, confirmLabel = "Eliminar", onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#131417] border-white/10 text-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl uppercase flex items-center gap-2">
            <Warning size={24} weight="fill" className="text-padel-danger" /> {title}
          </DialogTitle>
        </DialogHeader>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
        <div className="flex gap-2 justify-end mt-2">
          <Button data-testid="cancel-delete-btn" onClick={() => onOpenChange(false)} variant="ghost" className="font-heading uppercase tracking-widest text-muted-foreground hover:text-white">
            Cancelar
          </Button>
          <Button data-testid="confirm-delete-btn" onClick={() => { onConfirm(); onOpenChange(false); }} className="bg-padel-danger text-white font-heading uppercase tracking-widest rounded-none hover:bg-padel-danger/80">
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
